import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GREEN_YELLOW,
    detailIdProp: 'middlewareId',
    detailUrl: '/ArchMiddlewareDetail',
    listUrl: '/ArchMiddlewareList',
    mapProp: 'map',
    name: '中间件',
    textProp: 'middlewareName',
    type: 'MID',
}
